// ============================================================================
// ABC REAL FINANCIAL DATA - Imported from official Excel files
// Source files:
//   - ABC_Demonstracao_Resultados.xlsx
//   - ABC_Liquidez_Geracao_Caixa.xlsx
//   - ABC_Balanco_Patrimonial.xlsx
// ============================================================================
// IMPORTANT: All values are in USD (original values from source files)
// Conversion: Values displayed in M USD should divide by 1,000,000
// ============================================================================

// ============================================================================
// BUDGET DATA (Orçamento) - For Real vs Budget comparisons
// ============================================================================
export const budgetIncomeStatementData = {
  // 2025 BUDGET (Full Year) - Original budget values before actuals
  2025: {
    scenario: 'Budget',
    vendas: 104245929.96,
    prestacoesServicos: 0,
    outrosProveitos: 488245.93,
    variacaoPAePVF: 713918.15,
    totalProveitos: 105448094.03,
    cmvmc: -19230273.12,
    custosPessoal: -37924089.28,
    subcontratos: -4911257.45,
    geraisAdministrativos: -7612283.87,
    custosComercializacao: -72566810.01,
    totalCustosOperacionais: -32881284.03,
    ebitda: 32881284.03,
    margemEbitda: 0.3118,
    amortizacoes: -10682738.00,
    ebit: 22198546.03,
    resultadosNaoOperacionais: -9228740.00,
    resultadosFinanceiros: -1361735.00,
    resultadoAntesImposto: 11608071.03,
    impostoIndustrial: -2902017.76,
    resultadoLiquido: 8706053.27,
  },
};

// ============================================================================
// INCOME STATEMENT DATA (Demonstração de Resultados)
// ============================================================================
export const realIncomeStatementData = {
  // 2024 ACTUAL (Full Year)
  2024: {
    scenario: 'Actual',
    // Proveitos Operacionais (Operating Income)
    vendas: 93793537.73,                    // Vendas
    prestacoesServicos: 0,                  // Prestações de Serviços
    outrosProveitos: 206662.12,             // Outros Proveitos
    variacaoPAePVF: -2899898.84,            // NEW: Variação nos PA e PVF
    totalProveitos: 91100301.01,            // Total Proveitos
    
    // Custos Operacionais (Operating Costs)
    cmvmc: -12021142.83,                    // CMVMC
    custosPessoal: -32988766.30,            // Custos com Pessoal
    subcontratos: -6376332.57,              // Subcontratos
    geraisAdministrativos: -6726642.93,     // Gerais e Administrativos
    custosComercializacao: -60474453.93,    // Custos de Comercialização
    totalCustosOperacionais: -30625847.08,  // Total Custos Operacionais (Note: This appears to be EBITDA based on source)
    
    // Results
    ebitda: 30625847.08,                    // EBITDA
    margemEbitda: 0.3362,                   // 33.62% Margem EBITDA
    amortizacoes: -8310543.38,              // Amortizações
    ebit: 22315303.70,                      // EBIT
    resultadosNaoOperacionais: -6007646.77, // Resultados Não Operacionais
    resultadosFinanceiros: 1058388.09,      // Resultados Financeiros
    resultadoAntesImposto: 17366045.02,     // Resultado Antes de Imposto
    impostoIndustrial: -4040246.48,         // Imposto Industrial
    resultadoLiquido: 13325798.54,          // RESULTADO LÍQUIDO
  },
  
  // 2025 REAL (Full Year) - Updated with actual values
  2025: {
    scenario: 'Real',
    vendas: 103454861.00,              // UPDATED: Real 2025 sales
    prestacoesServicos: 0,
    outrosProveitos: 1080458.00,       // UPDATED: Real 2025 other income
    variacaoPAePVF: 713918.15,
    totalProveitos: 105249237.15,      // RECALCULATED: 103454861 + 0 + 1080458 + 713918.15
    cmvmc: -19230273.12,
    custosPessoal: -37924089.28,
    subcontratos: -4911257.45,
    geraisAdministrativos: -7612283.87,
    custosComercializacao: -72566810.01,
    totalCustosOperacionais: -32881284.03,
    ebitda: 32681523.43,               // RECALCULATED based on new totalProveitos
    margemEbitda: 0.3105,              // RECALCULATED: ebitda / totalProveitos
    amortizacoes: -10682738.00,
    ebit: 21998785.43,                 // RECALCULATED: ebitda - amortizacoes
    resultadosNaoOperacionais: -9228740.00,
    resultadosFinanceiros: -1361735.00,
    resultadoAntesImposto: 11408310.43, // RECALCULATED
    impostoIndustrial: -2852077.61,    // RECALCULATED: 25% of resultadoAntesImposto
    resultadoLiquido: 8556232.82,      // RECALCULATED
  },
  
  // 2026 BUDGET - Quarterly breakdown
  2026: {
    scenario: 'Budget',
    annual: {
      vendas: 131918324.09,
      prestacoesServicos: 0,
      outrosProveitos: 1310172.00,
      variacaoPAePVF: 1342720.90,
      totalProveitos: 134571216.99,
      cmvmc: -23808485.36,
      custosPessoal: -41611098.63,
      subcontratos: -7189716.89,
      geraisAdministrativos: -9310291.12,
      custosComercializacao: -83020778.91,
      totalCustosOperacionais: -51550438.09,
      ebitda: 51550438.09,
      margemEbitda: 0.3831,
      amortizacoes: -18925370.45,
      ebit: 32625067.63,
      resultadosNaoOperacionais: -4402500.00,
      resultadosFinanceiros: -5008642.05,
      resultadoAntesImposto: 23213925.58,
      impostoIndustrial: -5803481.39,
      resultadoLiquido: 17410444.18,
    },
    Q1: {
      vendas: 22626084.74,
      prestacoesServicos: 0,
      outrosProveitos: 256500.00,
      variacaoPAePVF: 1545435.27,
      totalProveitos: 24428020.01,
      cmvmc: -10402774.66,
      custosPessoal: -10402774.66,
      subcontratos: -1800046.32,
      geraisAdministrativos: -1597855.03,
      custosComercializacao: -19653375.02,
      totalCustosOperacionais: -4774644.99,
      ebitda: 4774644.99,
      margemEbitda: 0.1955,
      amortizacoes: -3763321.87,
      ebit: 1011323.13,
      resultadosNaoOperacionais: -1255375.00,
      resultadosFinanceiros: -1327473.23,
      resultadoAntesImposto: -1571525.10,
      impostoIndustrial: 0,
      resultadoLiquido: -1571525.10,
    },
    Q2: {
      vendas: 34883988.74,
      prestacoesServicos: 0,
      outrosProveitos: 376224.00,
      variacaoPAePVF: -64328.99,
      totalProveitos: 35195883.75,
      cmvmc: -10402774.66,
      custosPessoal: -10402774.66,
      subcontratos: -1805565.82,
      geraisAdministrativos: -2464288.99,
      custosComercializacao: -20880389.71,
      totalCustosOperacionais: -14315494.03,
      ebitda: 14315494.03,
      margemEbitda: 0.4067,
      amortizacoes: -4456470.33,
      ebit: 9859023.70,
      resultadosNaoOperacionais: -1105375.00,
      resultadosFinanceiros: -1388144.65,
      resultadoAntesImposto: 7365504.05,
      impostoIndustrial: -1448494.74,
      resultadoLiquido: 5917009.32,
    },
    Q3: {
      vendas: 37204125.30,
      prestacoesServicos: 0,
      outrosProveitos: 338724.00,
      variacaoPAePVF: -23131.66,
      totalProveitos: 37519717.64,
      cmvmc: -10402774.66,
      custosPessoal: -10402774.66,
      subcontratos: -1803790.31,
      geraisAdministrativos: -2624073.55,
      custosComercializacao: -21118941.45,
      totalCustosOperacionais: -16400776.19,
      ebitda: 16400776.19,
      margemEbitda: 0.4371,
      amortizacoes: -5301862.67,
      ebit: 11098913.52,
      resultadosNaoOperacionais: -1061375.00,
      resultadosFinanceiros: -1154370.46,
      resultadoAntesImposto: 8883168.05,
      impostoIndustrial: -2220792.01,
      resultadoLiquido: 6662376.04,
    },
    Q4: {
      vendas: 37204125.30,
      prestacoesServicos: 0,
      outrosProveitos: 338724.00,
      variacaoPAePVF: -115253.70,
      totalProveitos: 37427595.60,
      cmvmc: -10402774.66,
      custosPessoal: -10402774.66,
      subcontratos: -1780314.44,
      geraisAdministrativos: -2624073.55,
      custosComercializacao: -21368072.72,
      totalCustosOperacionais: -16059522.87,
      ebitda: 16059522.87,
      margemEbitda: 0.4291,
      amortizacoes: -5403715.59,
      ebit: 10655807.28,
      resultadosNaoOperacionais: -980375.00,
      resultadosFinanceiros: -1138653.71,
      resultadoAntesImposto: 8536778.58,
      impostoIndustrial: -2134194.64,
      resultadoLiquido: 6402583.93,
    },
  },
};

// ============================================================================
// CASH FLOW DATA (Liquidez e Geração de Caixa)
// ============================================================================
export const realCashFlowData = {
  // 2024 ACTUAL
  2024: {
    scenario: 'Actual',
    // Operating Activities
    recebimentosClientes: 74756800.35,
    pagamentosFornecedores: -35450574.17,
    pagamentosPessoal: -19181768.98,
    caixaGeradaOperacoes: 20124457.20,
    pagamentosEstado: -7723107.55,
    outrosRecebimentosPagamentos: 1573568.38,
    fluxoCaixaOperacional: 13974918.03,
    
    // Investing Activities
    fornecedoresAtivosFixos: -7609606.38,
    investimentosFinanceiros: 0,
    fluxoCaixaInvestimento: -7609606.38,
    
    // Financing Activities
    financiamentosObtidos: 5975416.21,
    jurosRendimentosSimilares: 0,
    reembolsoFinanciamentos: -2840136.88,
    jurosGastosSimilares: -1280407.72,
    dividendosPagos: 0,
    fluxoCaixaFinanciamento: 1854871.61,
    
    // Summary
    variacaoCaixa: 8220183.26,
    efeitoDiferencasCambio: 550196.21,
    caixaInicioPeriodo: 7681797.00,
    caixaFinalPeriodo: 16452176.00,
  },
  
  // 2025 BUDGET
  2025: {
    scenario: 'Budget',
    recebimentosClientes: 107902846.00,
    pagamentosFornecedores: -42954253.35,
    pagamentosPessoal: -22652863.00,
    caixaGeradaOperacoes: 42295729.65,
    pagamentosEstado: -7695177.78,
    outrosRecebimentosPagamentos: -741031.87,
    fluxoCaixaOperacional: 33859520.00,
    fornecedoresAtivosFixos: -32900746.00,
    investimentosFinanceiros: 0,
    fluxoCaixaInvestimento: -32900746.00,
    financiamentosObtidos: 12847833.00,
    jurosRendimentosSimilares: 25000.00,
    reembolsoFinanciamentos: -7768072.00,
    jurosGastosSimilares: -1094025.00,
    dividendosPagos: -9000000.00,
    fluxoCaixaFinanciamento: -4989264.00,
    variacaoCaixa: -4030490.00,
    efeitoDiferencasCambio: 672684.00,
    caixaInicioPeriodo: 16452176.00,
    caixaFinalPeriodo: 13094370.00,
  },
  
  // 2026 BUDGET
  2026: {
    scenario: 'Budget',
    annual: {
      recebimentosClientes: 133228496.09,
      pagamentosFornecedores: -49999826.26,
      pagamentosPessoal: -30019047.86,
      caixaGeradaOperacoes: 53209621.97,
      pagamentosEstado: -6698459.24,
      outrosRecebimentosPagamentos: -1302500.00,
      fluxoCaixaOperacional: 45208662.73,
      fornecedoresAtivosFixos: -43052885.19,
      investimentosFinanceiros: 0,
      fluxoCaixaInvestimento: -43052885.19,
      financiamentosObtidos: 20930956.00,
      jurosRendimentosSimilares: 120000.00,
      reembolsoFinanciamentos: -15479136.49,
      jurosGastosSimilares: -3927114.27,
      dividendosPagos: -6000000.00,
      fluxoCaixaFinanciamento: -4355294.76,
      variacaoCaixa: -2199517.23,
      efeitoDiferencasCambio: -200000.00,
      caixaInicioPeriodo: 13094370.00,
      caixaFinalPeriodo: 10694852.77,
    },
    Q1: {
      recebimentosClientes: 22882585.00,
      pagamentosFornecedores: -11153343.00,
      pagamentosPessoal: -7504762.00,
      caixaGeradaOperacoes: 4224480.00,
      pagamentosEstado: -2097591.00,
      outrosRecebimentosPagamentos: -480375.00,
      fluxoCaixaOperacional: 1646514.00,
      fornecedoresAtivosFixos: -11815110.00,
      investimentosFinanceiros: 0,
      fluxoCaixaInvestimento: -11815110.00,
      financiamentosObtidos: 10000000.00,
      jurosRendimentosSimilares: 30000.00,
      reembolsoFinanciamentos: -2255818.00,
      jurosGastosSimilares: -1057473.00,
      dividendosPagos: 0,
      fluxoCaixaFinanciamento: 6716709.00,
      variacaoCaixa: -3451887.00,
      efeitoDiferencasCambio: -50000.00,
      caixaInicioPeriodo: 13094370.00,
      caixaFinalPeriodo: 9592483.00,
    },
    Q2: {
      recebimentosClientes: 35260212.74,
      pagamentosFornecedores: -12566682.09,
      pagamentosPessoal: -7504761.96,
      caixaGeradaOperacoes: 15188768.68,
      pagamentosEstado: -1346345.70,
      outrosRecebimentosPagamentos: -330375.00,
      fluxoCaixaOperacional: 13512047.98,
      fornecedoresAtivosFixos: -12037863.65,
      investimentosFinanceiros: 0,
      fluxoCaixaInvestimento: -12037863.65,
      financiamentosObtidos: 4930956.00,
      jurosRendimentosSimilares: 30000.00,
      reembolsoFinanciamentos: -4285942.94,
      jurosGastosSimilares: -1118144.65,
      dividendosPagos: -3000000.00,
      fluxoCaixaFinanciamento: -3443131.59,
      variacaoCaixa: -1968947.26,
      efeitoDiferencasCambio: -50000.00,
      caixaInicioPeriodo: 9592483.00,
      caixaFinalPeriodo: 7573535.74,
    },
    Q3: {
      recebimentosClientes: 37542849.30,
      pagamentosFornecedores: -12730271.85,
      pagamentosPessoal: -7504761.96,
      caixaGeradaOperacoes: 17307815.49,
      pagamentosEstado: -2504046.13,
      outrosRecebimentosPagamentos: -286375.00,
      fluxoCaixaOperacional: 14517394.35,
      fornecedoresAtivosFixos: -7959656.02,
      investimentosFinanceiros: 0,
      fluxoCaixaInvestimento: -7959656.02,
      financiamentosObtidos: 0,
      jurosRendimentosSimilares: 30000.00,
      reembolsoFinanciamentos: -4232183.07,
      jurosGastosSimilares: -884370.46,
      dividendosPagos: -3000000.00,
      fluxoCaixaFinanciamento: -8086553.53,
      variacaoCaixa: -1528815.20,
      efeitoDiferencasCambio: -50000.00,
      caixaInicioPeriodo: 7573535.74,
      caixaFinalPeriodo: 5994720.54,
    },
    Q4: {
      recebimentosClientes: 37542849.30,
      pagamentosFornecedores: -13549529.32,
      pagamentosPessoal: -7504761.96,
      caixaGeradaOperacoes: 16488558.17,
      pagamentosEstado: -750476.20,
      outrosRecebimentosPagamentos: -205375.00,
      fluxoCaixaOperacional: 15532706.97,
      fornecedoresAtivosFixos: -11240256.02,
      investimentosFinanceiros: 0,
      fluxoCaixaInvestimento: -11240256.02,
      financiamentosObtidos: 6000000.00,
      jurosRendimentosSimilares: 30000.00,
      reembolsoFinanciamentos: -4705192.51,
      jurosGastosSimilares: -867125.71,
      dividendosPagos: 0,
      fluxoCaixaFinanciamento: 457681.78,
      variacaoCaixa: 4750132.73,
      efeitoDiferencasCambio: -50000.00,
      caixaInicioPeriodo: 5994720.54,
      caixaFinalPeriodo: 10694853.28,
    },
  },
};

// ============================================================================
// BALANCE SHEET DATA (Balanço Patrimonial) - FROM NEW EXCEL FILE v2
// ============================================================================
export const realBalanceSheetData = {
  // 2024 ACTUAL - FROM NEW EXCEL FILE v2
  2024: {
    scenario: 'Actual',
    // ACTIVO - Activos não Correntes
    imobilizacoesCorporeas: 30847846.63,
    imobilizacoesIncorporeas: 330014.11,
    totalActivosNaoCorrentes: 31177860.74,
    // ACTIVO - Activos Correntes
    existencias: 23761420.24,
    contasAReceber: 23661414.44,
    disponibilidades: 16452176.27,
    outrosActivosCorrentes: 1371203.41,
    totalActivosCorrentes: 65246214.36,
    totalActivo: 96424075.10,
    // CAPITAL PRÓPRIO
    capital: 155.66,
    reservas: 15053978.45,
    resultadosTransitados: 19452510.43,
    resultadosExercicio: 13325798.54,
    outrosInstrumentosCapitalProprio: 0,
    totalCapitalProprio: 47832443.08,
    // PASSIVO NÃO CORRENTE
    emprestimosMedioLongoPrazo: 8302361.56,
    provisoesOutrosRiscosEncargos: 16348460.13,
    outrosPassivosNaoCorrentes: 0,
    totalPassivoNaoCorrente: 24650821.69,
    // PASSIVO CORRENTE
    parteCorrenteEmprestimos: 3689938.56,
    contasAPagar: 10697113.19,
    emprestimosCurtoPrazo: 0,
    outrosPassivosCorrentes: 9553758.57,
    totalPassivoCorrente: 23940810.32,
    // TOTAL
    totalCapitalProprioEPassivo: 96424075.10,
  },
  
  // 2025 BUDGET - FROM NEW EXCEL FILE v2
  2025: {
    scenario: 'Budget',
    // ACTIVO - Activos não Correntes
    imobilizacoesCorporeas: 45532460.32,
    imobilizacoesIncorporeas: 1017386.41,
    totalActivosNaoCorrentes: 46549846.73,
    // ACTIVO - Activos Correntes
    existencias: 17792794.00,
    contasAReceber: 14224834.11,
    disponibilidades: 13094370.00,
    outrosActivosCorrentes: 1835312.25,
    totalActivosCorrentes: 46947310.36,
    totalActivo: 93497157.09,
    // CAPITAL PRÓPRIO
    capital: 155.66,
    reservas: 15053978.45,
    resultadosTransitados: 22803308.97,
    resultadosExercicio: 8556232.82,    // UPDATED: Consistent with Income Statement 2025
    outrosInstrumentosCapitalProprio: 0,
    totalCapitalProprio: 46413675.90,   // RECALCULATED
    // PASSIVO NÃO CORRENTE
    emprestimosMedioLongoPrazo: 4612423.00,
    provisoesOutrosRiscosEncargos: 21177200.13,
    outrosPassivosNaoCorrentes: 0,
    totalPassivoNaoCorrente: 25789623.13,
    // PASSIVO CORRENTE
    parteCorrenteEmprestimos: 8005521.00,
    contasAPagar: 10250228.77,
    emprestimosCurtoPrazo: 0,
    outrosPassivosCorrentes: 2888287.77,
    totalPassivoCorrente: 21144037.54,
    // TOTAL
    totalCapitalProprioEPassivo: 93497157.02,
  },
  
  // 2026 BUDGET - FROM NEW EXCEL FILE v2
  2026: {
    scenario: 'Budget',
    // ACTIVO - Activos não Correntes
    imobilizacoesCorporeas: 73273067.98,
    imobilizacoesIncorporeas: 7402382.17,
    totalActivosNaoCorrentes: 80675450.15,
    // ACTIVO - Activos Correntes
    existencias: 19135514.90,
    contasAReceber: 17555546.51,
    disponibilidades: 10694852.77,
    outrosActivosCorrentes: 1905312.25,
    totalActivosCorrentes: 49291226.44,
    totalActivo: 129966676.60,
    // CAPITAL PRÓPRIO
    capital: 155.66,
    reservas: 15053978.45,
    resultadosTransitados: 31509362.24,
    resultadosExercicio: 17410444.18,
    outrosInstrumentosCapitalProprio: 0,
    totalCapitalProprio: 63973940.54,
    // PASSIVO NÃO CORRENTE
    emprestimosMedioLongoPrazo: 11810382.77,
    provisoesOutrosRiscosEncargos: 25177200.13,
    outrosPassivosNaoCorrentes: 0,
    totalPassivoNaoCorrente: 36987582.90,
    // PASSIVO CORRENTE
    parteCorrenteEmprestimos: 13279594.32,
    contasAPagar: 12537271.06,
    emprestimosCurtoPrazo: 0,
    outrosPassivosCorrentes: 3188287.77,
    totalPassivoCorrente: 29005153.16,
    // TOTAL
    totalCapitalProprioEPassivo: 129966676.60,
  },
};

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================

// Convert raw USD to millions USD for display
export const toMillionsUSD = (value) => value / 1000000;

// Get data availability status
export const getDataAvailability = () => ({
  incomeStatement: {
    2024: { actual: true, budget: false },
    2025: { actual: false, budget: true },
    2026: { actual: false, budget: true, quarterly: true },
  },
  cashFlow: {
    2024: { actual: true, budget: false },
    2025: { actual: false, budget: true },
    2026: { actual: false, budget: true, quarterly: true },
  },
  balanceSheet: {
    2024: { actual: true, budget: false },
    2025: { actual: false, budget: true },
    2026: { actual: false, budget: true },
  },
});

// ============================================================================
// MAPPING SUMMARY
// ============================================================================
/*
SOURCE FILE MAPPING:

ABC_Demonstracao_Resultados.xlsx:
  - Vendas → vendas
  - Prestações de Serviços → prestacoesServicos
  - Outros Proveitos → outrosProveitos
  - Variação nos PA e PVF → variacaoPAePVF (NEW LINE ITEM)
  - Total Proveitos → totalProveitos
  - CMVMC → cmvmc
  - Custos com Pessoal → custosPessoal
  - Subcontratos → subcontratos
  - Gerais e Administrativos → geraisAdministrativos
  - Custos de Comercialização → custosComercializacao
  - Total Custos Operacionais → totalCustosOperacionais
  - EBITDA → ebitda
  - Margem EBITDA → margemEbitda
  - Amortizações → amortizacoes
  - EBIT → ebit
  - Resultados Não Operacionais → resultadosNaoOperacionais
  - Resultados Financeiros → resultadosFinanceiros
  - Resultado Antes de Imposto → resultadoAntesImposto
  - Imposto Industrial → impostoIndustrial
  - RESULTADO LÍQUIDO → resultadoLiquido

ABC_Liquidez_Geracao_Caixa.xlsx:
  - Recebimentos de Clientes → recebimentosClientes
  - Pagamentos a Fornecedores → pagamentosFornecedores
  - Pagamentos ao Pessoal → pagamentosPessoal
  - Caixa Gerado pelas Operações → caixaGeradaOperacoes
  - Pagamentos ao Estado → pagamentosEstado
  - Outros Recebimentos/Pagamentos → outrosRecebimentosPagamentos
  - Fluxo de Caixa Operacional (1) → fluxoCaixaOperacional
  - Fornecedores de Ativos Fixos → fornecedoresAtivosFixos
  - Investimentos Financeiros → investimentosFinanceiros
  - Fluxo de Caixa de Investimento (2) → fluxoCaixaInvestimento
  - Financiamentos Obtidos → financiamentosObtidos
  - Juros e Rendimentos Similares → jurosRendimentosSimilares
  - Reembolso de Financiamentos → reembolsoFinanciamentos
  - Juros e Gastos Similares → jurosGastosSimilares
  - Dividendos Pagos → dividendosPagos
  - Fluxo de Caixa de Financiamento (3) → fluxoCaixaFinanciamento
  - Variação de Caixa (1+2+3) → variacaoCaixa
  - Efeito das Diferenças de Câmbio → efeitoDiferencasCambio
  - Caixa no Início do Período → caixaInicioPeriodo
  - Caixa no Final do Período → caixaFinalPeriodo

ABC_Balanco_Patrimonial.xlsx:
  - Imobilizações Corpóreas → imobilizacoesCorporeas
  - Imobilizações Incorpóreas → imobilizacoesIncorporeas
  - Total Activos não Correntes → totalActivosNaoCorrentes
  - Existências → existencias
  - Contas a Receber → contasAReceber
  - Disponibilidades → disponibilidades
  - Outros Activos Correntes → outrosActivosCorrentes
  - Total Activos Correntes → totalActivosCorrentes
  - Total do Activo → totalActivo
  - Capital → capital
  - Reservas → reservas
  - Resultados Transitados → resultadosTransitados
  - Resultados do Exercício → resultadosExercicio
  - Outros Instrumentos de Capital Próprio → outrosInstrumentosCapitalProprio
  - Total Capital Próprio → totalCapitalProprio
  - Empréstimos de Médio e Longo Prazos → emprestimosMedioLongoPrazo
  - Provisões para Outros Riscos e Encargos → provisoesOutrosRiscosEncargos
  - Outros Passivos não Correntes → outrosPassivosNaoCorrentes
  - Total Passivo não Corrente → totalPassivoNaoCorrente
  - Parte Cor. dos Empr. a Médio e Longo Prazos → parteCorrenteEmprestimos
  - Contas a Pagar → contasAPagar
  - Empréstimos de Curto Prazo → emprestimosCurtoPrazo
  - Outros Passivos Correntes → outrosPassivosCorrentes
  - Total Passivo Corrente → totalPassivoCorrente
  - Total do Capital Próprio e Passivo → totalCapitalProprioEPassivo
*/
